/* -------------------------------------
 UNFINISHED APP Config Service
 - Details about the application. 

 - Set the appinstance to:
 Dev = console logs turned on 
 Live = console logs turned off
-------------------------------------- */

import { Injectable } from '@angular/core';
import { AppInstance } from '../shared/enums/app-instance.enum';

export class AppConfigBase {
    constructor(public readonly appInstance: AppInstance) { }

    public getInstanceName(): string {
        let value = this.appInstance;
        return AppInstance[value];
    }
}

@Injectable()
export class AppConfig extends AppConfigBase{
   
    constructor() {
        super(AppInstance.Dev); //Set app instance here
    }
}



// WEBPACK FOOTER //
// ./src/shared/app-config.service.ts